import { Component, OnInit, ViewChild } from "@angular/core";
import { SubHeaderButtonService } from "@app/services/sub-header-button.service";

import { MatPaginator, MatTableDataSource } from "@angular/material";
import { MaterialModule } from "mat-modules";
import { SelectionModel } from "@angular/cdk/collections";
import { UsersService } from "@app/api/users.service";
import { RootSpinnerService } from "@app/services/root-spinner.service";
import moment from "moment";

//environment
import { environment } from "@app/../environments/environment";
import { User } from "@app/model/user";

@Component({
	selector: "kt-app-user-management",
	templateUrl: "./app-user-management.component.html",
	styleUrls: ["./app-user-management.component.scss"],
})
export class AppUserManagementComponent implements OnInit {
	lstUser: User[] = [];

	allUsers = [];
	totalUsers = 0;
	pageIndex = 1;
	pagesize = 10;
	avatar = "./assets/media/users/default.jpg";

	loading: boolean = false;

	displayedColumns: string[] = [
		"select",
		"name",
		"employee_code",
		"gender",
		"birthday",
		"email",
		"cell_phone",
		"actions",
	];
	selection = new SelectionModel<Element>(true, []);

	constructor(
		public subHeaderButtonService: SubHeaderButtonService,
		private UsersService: UsersService
	) {}

	ngOnInit() {
		this.subHeaderButtonService.setButtonCollection([
			{
				name: "add-new",
				type: "Text",
				icon: "flaticon-download-1",
				label: "Thêm mới",
				routerlink: "/user-management/create",
			},
		]);

		this.getData();
	}

	ngOnDestroy() {
		this.subHeaderButtonService.setButtonCollection([]);
	}
	getData() {
		RootSpinnerService.show();
		this.loading = true;
		this.UsersService.apiUsersGet(
			"",
			"id",
			this.pageIndex,
			this.pagesize
		).subscribe((res) => {
			this.allUsers = [...res.data.collection];
			this.totalUsers = res.data.total;
			this.pageIndex = res.data.pageIndex;

			for (let i = 0; i < this.allUsers.length; i++) {
				this.allUsers[i].birthday = this.formatDate(
					this.allUsers[i].birthday
				);
				this.allUsers[i].avatar =
					environment.backendhost + this.allUsers[i].avatar;
				if (this.allUsers[i].middle_name != null) {
					this.allUsers[i].FullName =
						this.allUsers[i].last_name +
						" " +
						this.allUsers[i].middle_name +
						" " +
						this.allUsers[i].first_name;
				} else {
					this.allUsers[i].FullName =
						this.allUsers[i].last_name +
						" " +
						this.allUsers[i].first_name;
				}
			}

			this.lstUser = [...this.allUsers];
			RootSpinnerService.hide();
			this.loading = false;
		});
	}

	formatDate(date) {
		if (date == null) {
			return "";
		}
		try {
			let utcDate = moment.utc(date).toDate();
			let fmDate = moment(utcDate).format("DD/MM/YYYY");
			return fmDate;
		} catch (error) {
			return "";
		}
	}

	paginatorChange(event) {
		this.pagesize = event.pageSize;
		this.pageIndex = event.pageIndex + 1;
		this.getData();
	}

	/** Whether the number of selected elements matches the total number of rows. */
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.allUsers.length;
		return numSelected === numRows;
	}

	/** Selects all rows if they are not all selected; otherwise clear selection. */
	masterToggle() {
		this.isAllSelected()
			? this.selection.clear()
			: this.allUsers.forEach((row) => this.selection.select(row));
	}
}
